var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        [
          _c("statisticsBox", {
            ref: "formBox",
            on: { confirmData: _vm.confirmData },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "mt14", attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-card",
                [
                  _c("div", { staticClass: "statistics-title" }, [
                    _vm._v("资产金额"),
                  ]),
                  _vm._v(" "),
                  _c("echartBox", {
                    attrs: {
                      "option-data": _vm.optionData,
                      styles: _vm.styles1,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", [
                _c("div", { staticClass: "statistics-title" }, [
                  _vm._v("物资变动情况"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content border-none" }, [
                  _c("ul", { staticClass: "content-ul" }, [
                    _c(
                      "li",
                      [
                        _c(
                          "el-row",
                          [
                            _c("el-col", { attrs: { span: 16 } }, [
                              _vm._v("采购数量"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { staticClass: "text-right", attrs: { span: 8 } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      circle: "",
                                      size: "small",
                                      type: "primary",
                                    },
                                  },
                                  [
                                    _c("count-to", {
                                      attrs: {
                                        duration: 1000,
                                        "end-val": Number(
                                          _vm.storageCount.put_count
                                        ),
                                        "start-val": 0,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c(
                          "el-row",
                          [
                            _c("el-col", { attrs: { span: 16 } }, [
                              _vm._v("固定物资领取数量"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { staticClass: "text-right", attrs: { span: 8 } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      circle: "",
                                      size: "small",
                                      type: "success",
                                    },
                                  },
                                  [
                                    _c("count-to", {
                                      attrs: {
                                        duration: 1000,
                                        "end-val": _vm.storageCount.fixed_count,
                                        "start-val": 0,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c(
                          "el-row",
                          [
                            _c("el-col", { attrs: { span: 16 } }, [
                              _vm._v("消耗物资领取数量"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { staticClass: "text-right", attrs: { span: 8 } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      circle: "",
                                      size: "small",
                                      type: "warning",
                                    },
                                  },
                                  [
                                    _c("count-to", {
                                      attrs: {
                                        duration: 1000,
                                        "end-val": _vm.storageCount.temp_count,
                                        "start-val": 0,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c(
                          "el-row",
                          [
                            _c("el-col", { attrs: { span: 16 } }, [
                              _vm._v("报废数量"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { staticClass: "text-right", attrs: { span: 8 } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      circle: "",
                                      size: "small",
                                      type: "info",
                                    },
                                  },
                                  [
                                    _c("count-to", {
                                      attrs: {
                                        duration: 1000,
                                        "end-val": _vm.storageCount.scrap_count,
                                        "start-val": 0,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c(
                          "el-row",
                          [
                            _c("el-col", { attrs: { span: 16 } }, [
                              _vm._v("维修数量"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { staticClass: "text-right", attrs: { span: 8 } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      circle: "",
                                      size: "small",
                                      type: "info",
                                    },
                                  },
                                  [
                                    _c("count-to", {
                                      attrs: {
                                        duration: 1000,
                                        "end-val":
                                          _vm.storageCount.repair_count,
                                        "start-val": 0,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { ref: "rows", staticClass: "mt14", attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", [
                _c("div", { staticClass: "pie-tab" }, [
                  _c("div", { staticClass: "statistics-title mb20" }, [
                    _vm._v("库存预警"),
                  ]),
                  _vm._v(" "),
                  _vm.stockData.length > 0
                    ? _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.stockData,
                                "default-expand-all": "",
                                "row-key": "id",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "物资名称",
                                  "min-width": "100",
                                  prop: "name",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "规格型号",
                                  "min-width": "100",
                                  prop: "units",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物资分类",
                                  "min-width": "100",
                                  prop: "cate.cate_name",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "当前库存",
                                  "min-width": "100",
                                  prop: "stock",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("public.operation"),
                                  fixed: "right",
                                  prop: "describe",
                                  width: "80",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleManage(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("补货")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3466555480
                                ),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "block" },
                            [
                              _c("el-pagination", {
                                attrs: {
                                  "current-page": _vm.stockWhere.page,
                                  "page-size": _vm.stockWhere.limit,
                                  total: _vm.stockTotal,
                                  layout: "prev, pager, next",
                                },
                                on: {
                                  "size-change": _vm.handleStockSize,
                                  "current-change": _vm.pageStockChange,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("default-page", {
                            attrs: { height: "calc(50vh - 158px)", index: 14 },
                          }),
                        ],
                        1
                      ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", [
                _c("div", { staticClass: "pie-tab" }, [
                  _c("div", { staticClass: "statistics-title mb20" }, [
                    _vm._v("物资变动明细"),
                  ]),
                  _vm._v(" "),
                  _vm.detailedDat.length > 0
                    ? _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.detailLoading,
                                  expression: "detailLoading",
                                },
                              ],
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.detailedDat,
                                height: _vm.tableHeight,
                                "default-expand-all": "",
                                "row-key": "id",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "物资名称",
                                  "min-width": "130",
                                  prop: "storage.name",
                                  "show-overflow-tooltip": "",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物资分类",
                                  "min-width": "100",
                                  prop: "storage.cate.cate_name",
                                  "show-overflow-tooltip": "",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "规格型号",
                                  "min-width": "100",
                                  prop: "storage.units",
                                  "show-overflow-tooltip": "",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "变动情况",
                                  "min-width": "100",
                                  prop: "stock",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          row.types === 0
                                            ? [
                                                _vm._v(
                                                  "\n                    入库量\n                    "
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "color1" },
                                                  [
                                                    _vm._v(
                                                      "+" + _vm._s(row.num)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          row.types === 1
                                            ? [
                                                _vm._v(
                                                  "\n                    领用量\n                    "
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "color2" },
                                                  [
                                                    _vm._v(
                                                      "+" + _vm._s(row.num)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          row.types === 4
                                            ? [
                                                _vm._v(
                                                  "\n                    报废量\n                    "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "color-success",
                                                  },
                                                  [_vm._v("+1")]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1212994710
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "变动时间",
                                  "min-width": "100",
                                  prop: "storage.units",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm
                                                  .$moment(scope.row.created_at)
                                                  .format("yyyy-MM-DD")
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2253445902
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  label: "操作人",
                                  prop: "creater.name",
                                  width: "80",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "none-button over-text",
                                              attrs: { type: "text" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.creater
                                                    ? scope.row.creater.name
                                                    : "--"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2777748844
                                ),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "block" },
                            [
                              _c("el-pagination", {
                                attrs: {
                                  "current-page": _vm.where.page,
                                  "page-size": _vm.where.limit,
                                  total: _vm.total,
                                  layout: "prev, pager, next",
                                },
                                on: {
                                  "size-change": _vm.handleSizeChange,
                                  "current-change": _vm.pageChange,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("default-page", {
                            attrs: {
                              index: 14,
                              "min-height": _vm.styles1.height,
                            },
                          }),
                        ],
                        1
                      ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("material-dialog", {
        ref: "materialDialog",
        attrs: { "from-data": _vm.fromData },
        on: { isOk: _vm.handleMaterial },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }